import { render, staticRenderFns } from "./ClaimsCheck.vue?vue&type=template&id=8258235c&scoped=true"
import script from "./ClaimsCheck.vue?vue&type=script&lang=ts"
export * from "./ClaimsCheck.vue?vue&type=script&lang=ts"
import style0 from "./ClaimsCheck.vue?vue&type=style&index=0&id=8258235c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8258235c",
  null
  
)

export default component.exports